import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "underscore";
import { fetchPaymentConfigRequest } from "../../store/shopping/shopping.actions";
import { getPaymentConfig } from "../../store/shopping/shopping.selector";
import { getUserProfile } from "../../store/user/user.selector";
import SocialAPI from "../../store/social/social.api";
import moment from "moment";
import { letterValue } from "../../helpers/utility";
import { useNavigate } from "react-router-dom";
import StripePaymentForm from "../payment/stripePaymentForm";
import Swal from "sweetalert2";
var stripePromise = null;
const ELEMENTS_OPTIONS = {
    fonts: [
        {
            cssSrc: "https://fonts.googleapis.com/css?family=Roboto",
        },
    ],
};

export default function OrderPayment(props) {
    const dispatch = useDispatch();
    const history = useNavigate();
    const [cart, setCart] = useState({});
    const [selectedAddress, setSelectedAddress] = useState("");

    useEffect(() => {
        if (props.cartId && props.items && props.totalPrices) {
            setCart({
                _id: props.cartId,
                cartItems: props.items,
                totalPrices: props.totalPrices,
            });

            setSelectedAddress(props.selectedAddress);
        }
    }, [props]);

    useEffect(() => {
        dispatch(fetchPaymentConfigRequest());
    }, []);

    const { userProfile, paymentConfig } = useSelector((state) => {
        return {
            userProfile: getUserProfile(state),
            paymentConfig: getPaymentConfig(state),
        };
    });

    useEffect(() => {
        if (paymentConfig && paymentConfig.publicKey) {
            stripePromise = loadStripe(paymentConfig.publicKey);
        }
    }, [paymentConfig]);

    const handleSave = (_token, _addresses) => {
        let totalShippingFee = _.reduce(
            shippingPrices,
            function (memo, num) {
                return memo + num;
            },
            0
        );
        let totalProductPrice = _.reduce(
            prices,
            function (memo, num) {
                return memo + num;
            },
            0
        );
        const carts = cart.cartItems.map((x) => {
            return `<tr>
                    <td style="text-align: left; font-weight: 600;">${
                        x.product.name
                    }</td>
                    <td style="text-align: right; font-weight: 600">${
                        x.quantity
                    }</td>
                    <td style="text-align: right; color:#0038FF; font-weight: 600">${
                        userProfile.country.currency
                    } ${x.product.price.toFixed(2)}</td>
                </tr>`;
        });
        const mail = `       <p style="text-align: center;
        font-weight: bold;
        font-size: 22px;
        margin: 0;
        padding: 8px;">
            Your Ulalive order is confirmed.
        </p>
        <p style="text-align: center;
        font-weight: bold;
        line-height: 20px;
        margin: 0;
        font-size: 16px;
        padding: 8px;">
            And we’re just as excited as you are.
        </p>
        <div style="background-color:#ffffff; border: 1px solid #CECECE; margin: 16px;padding : 16px;    max-width: 600px;
        margin: 0 auto;    border-radius: 12px;">
            <p style="color:#6f51ff;font-weight:bold;text-align:center;margin: 0;">Here’s what you ordered:</p>
            <table width="100%" style="line-height:30px">
                <tr>
                    <td>Order #: ${letterValue(cart._id).substring(0, 8)}</td>
                    <td colspan="2" style="text-align:right;" align="right">Order Date:${moment().format(
                        "DD/MM/YYYY"
                    )}</td>
                </tr>
                <tr>
                    <td colspan="3">
                        <p style="border-bottom: 1px solid #CECECE;"></p>
                    </td>
                </tr>
                <tr>
                    <th style="text-align: left; color:#A1A1A1">ITEM</th>
                    <th style="text-align: right; color:#A1A1A1">QTY</th>
                    <th style="text-align: right; color:#A1A1A1">PRICE</th>
                </tr>
				${carts.join("")}
                <tr>
                    <td colspan="3">
                        <p style="border-bottom: 1px solid #CECECE;"></p>
                    </td>
                </tr>
                <tr>
                    <td style="text-align: right; color:#000" colspan="2">Subtotal</td>
                    <td style="text-align: right; color:#000">${
                        userProfile.country.currency
                    } ${totalProductPrice.toFixed(2)}</td>
                </tr>
                <tr>
                    <td style="text-align: right; color:#000" colspan="2">Shipping</td>
                    <td style="text-align: right; color:#000">${
                        userProfile.country.currency
                    } ${totalShippingFee.toFixed(2)}</td>
                </tr>
                <tr>
                    <td style="text-align: right; color:#000;font-weight: 700;" colspan="2">Total</td>
                    <td style="text-align: right; color:#000; font-weight: 700;">${
                        userProfile.country.currency
                    } ${(totalProductPrice + totalShippingFee).toFixed(2)}</td>
                </tr>
                <tr>
                    <td colspan="3">
                        <p style="border-bottom: 1px solid #CECECE;"></p>
                    </td>
                </tr>
                <tr>
                    <td colspan="3">
                        <p style="margin: 0;padding:0">SHIPPING METHOD: Yet to Update (Tentative 5 Business Days)</p>
                        <p style="margin: 0;padding:0;font-size: 12px;font-style: italic;">*Some shipping areas may take
                            up to 7 business days for delivery.</p>

                    </td>
                </tr>
                <tr>
                    <td colspan="3">
                        <p style="border-bottom: 1px dashed #CECECE;"></p>
                    </td>
                </tr>
                <tr>
                    <td colspan="3">
                       <span style="color:#0038FF; font-weight: 600">Sent to:</span><br/> 
                        ${selectedAddress.name},<br/>
                        ${selectedAddress.address},<br/>
                        ${selectedAddress.subAddress},<br/>
                        ${selectedAddress.state} ${
            selectedAddress.postCode
        }<br/>
                        ${selectedAddress.phone}<br/>
                    </td>
                </tr>
            </table>
        </div>`;

        SocialAPI.sendEmailNotification({
            message: mail,
            subject: "Order Confirmation From Ulalive",
            to: userProfile.email,
        });

        // let shippingPrices = cart.cartItems.map((x) => {
        // 	return x.product.shippingFee * x.quantity;
        // });
        // let prices =  cart.cartItems.map((x) => {
        // 	return x.product.price * x.quantity;
        // });
        // let totalShippingFee = _.reduce(shippingPrices, function (memo, num) { return memo + num }, 0);
        // let totalProductPrice = _.reduce(prices, function (memo, num) { return memo + num }, 0);
        // let data = {
        // 	'carts': cart._id,
        // 	'orderItems': cart.cartItems.map((x) => {
        // 		return {
        // 			product: x.product._id,
        // 			quantity: x.quantity,
        // 			prices: x.product.price,
        // 			shippingFee : x.product.shippingFee
        // 		}
        // 	}),
        // 	'notes': "Test",
        // 	'shippingFee': totalShippingFee,
        // 	'tax': 0,
        // 	'otherFee': 0,
        // 	'totalPrices': totalProductPrice,
        // 	'seller': cart.cartItems[0].product.user.id,
        // 	'sellerUserName': cart.cartItems[0].product.user.userName,
        // 	'buyer': userProfile._id,
        // 	'buyerUserName': userProfile.userName,
        // 	'livestream': cart.cartItems[0].livestreams[0],
        // 	'livestreamTitle': cart.cartItems[0].livestreams[0],
        // 	'deliveryAddress': selectedAddress,
        // 	'orderStatus': "Pending",
        // 	'currency': userProfile.country.currency
        // }

        // dispatch((addOrderRequest(data)));
        // Swal.fire({
        // 	title: 'Payment successful',
        // 	text: 'Thank you for purchasing',
        // 	icon: 'success',
        // 	showCancelButton: true,
        // 	confirmButtonColor: 'green',
        // 	cancelButtonText: "Cancel",
        // 	confirmButtonText: "Go to my order page",
        // 	customClass: {
        // 		cancelButton: 'order-1 right-gap',
        // 		confirmButton: 'order-2',
        // 		denyButton: 'order-3',
        // 	}
        // }).then((x) => {
        // 	if (x.isConfirmed) {
        // 		history("/page/orderComplete");
        // 	}
        // });

        history("/page/orderComplete");
    };

    if (!cart.cartItems) {
        return <p></p>;
    }

    let prices = cart.cartItems.map((x) => {
        return x.product.price * x.quantity;
    });

    let shippingPrices = cart.cartItems.map((x) => {
        return x.product.shippingFee * x.quantity;
    });

    return (
        <>
            {stripePromise && selectedAddress._id ? (
                <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
                    <StripePaymentForm
                        enableFPX={true}
                        type="checkout"
                        userProfile={userProfile}
                        shipment={props.shipment}
                        courier={props.courier}
                        discount={props.discounts}
                        paymentConfig={paymentConfig}
                        address={selectedAddress}
                        OnSuccess={handleSave}
                        onCancel={() => props.onCancel()}
                        OnError={(err) => console.log(err)}
                        billingAddress={selectedAddress._id}
                        cart={cart}
                    />
                </Elements>
            ) : (
                <span />
            )}
        </>
    );
}
